import type { FaireProductEntity } from "../../entity_types/product";

export const p_h42ckgd37y: FaireProductEntity = {
  token: "p_h42ckgd37y",
  type: "product",
  name: "Contrasting Color Sports Bra+high waist leggings 2-piece set",
  brandToken: "b_f5yy4uappq",
  brandName: "WONDERXFANS",
  imageUrl:
    "https://cdn.faire.com/fastly/5db73a1dd4643e673093a94c84e75fcb662b6bcda8d9b35b0d04678046f224d5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/28aad4904729386d5020465edd10860871934f08177f81ef7400fe02f48a328f.jpeg",
    "https://cdn.faire.com/fastly/7ebe1684d497c7f40c0e4a0b05ee6bd2bc15c7bd26e197faabf39a296cb5bfff.jpeg",
    "https://cdn.faire.com/fastly/71f1217dbdd6464a877073e35ee8679860df7583c62518f4e2ba875fffbd4d2e.jpeg",
    "https://cdn.faire.com/fastly/8cd355f722bd247f3bf3c59bd031a15a9547c5b0d97823cd908836e63a090cf0.jpeg",
    "https://cdn.faire.com/fastly/343996d20223ab11f977376539c136e6dfa48cf17ff064985bb4f3769b4d408e.jpeg",
    "https://cdn.faire.com/fastly/bff92957aba9d04ee40eb8caf16172b75b94c9aa3cd2c7ec9c75ee3c12ad9daa.jpeg",
    "https://cdn.faire.com/fastly/2a53bf60b4791b2edb98578763f1591315e50cc0a5dc35f80bf13a9786bed7ab.jpeg",
    "https://cdn.faire.com/fastly/5fc1cf928d13da18be1ed5e7b2e9c7cb26631d574f0208acf4e914a73e3a2f80.jpeg",
    "https://cdn.faire.com/fastly/2337a121bf62592cc8f4b440c02bdd73e3827ff0ff9bcc531fa3fefbeb76253d.jpeg",
  ],
  priceDollars: 23.99,
  description:
    "Design Details\nBreathable wide shoulder straps yoga bra and high waist leggings set design\nUnique Design Points:\nWide shoulder straps for added comfort and support + removable padding for versatile wear\nExtended hem for a comfortable fit + contrasting color line design\nHigh-rise waistband to stay in place during movements + butt lift design for a flattering silhouette\nAvoid awkward front lines + full length for full coverage and warmth + folding waist design\nSmooth comfortable fit gently to accentuate your shape\nFabric details\nFabric Composition:\n78% Nylon + 22% Spandex\nFabric Features:\nSo buttery soft and fit body\nSweat-wicking\nWear-resistant and non-deforming\nSize Details\nModel information:176CM,62KG,BWH 85/63/93CM,wearing size S.\nFit & Feel\nNormal\nSkin-friendly\nFunction Details\nMedium stretch for entry-level training\nSuitable for exercise\nYoga",
  tags: [],
  msrpDollars: 47.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:54.184Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
